import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { isPlatform } from '@ionic/vue';
import axios from 'axios';

const baseUrl = () => process.env.VUE_APP_API_URL || '';

async function getToken(): Promise<string> {
  const { value } = await Preferences.get({ key: 'jwt' });
  return value || '';
}

async function api<T>(method: string, path: string, body?: unknown, params?: Record<string, string>): Promise<T> {
  const token = await getToken();
  const url = `${baseUrl()}api${path}`;
  const headers: Record<string, string> = { Authorization: `Bearer ${token}` };
  if (isPlatform('ios') || isPlatform('android')) {
    const opts: Record<string, unknown> = { url, method, headers, readTimeout: 60000 };
    if (body != null) {
      headers['Content-Type'] = 'application/json';
      opts.data = JSON.stringify(body);
    }
    if (params) opts.params = params;
    const res = await CapacitorHttp.request(opts as any);
    if (res.status >= 400) throw new Error((res.data as any)?.message || `HTTP ${res.status}`);
    return res.data as T;
  }
  const config: Record<string, unknown> = { url: `api${path}`, method, headers };
  if (body) config.data = body;
  if (params) config.params = params;
  const { data } = await axios.request<T>(config as any);
  return data;
}

export interface ICreateReleasePaymentResult {
  paymentId: string;
  redirectUrl: string;
  amountKopecks: number;
}

export default {
  async createReleasePurchase(
    releaseId: number,
    customerEmail?: string
  ): Promise<ICreateReleasePaymentResult> {
    const body: { customerEmail?: string; returnToApp?: boolean } = {};
    if (customerEmail != null && customerEmail.trim()) body.customerEmail = customerEmail.trim();
    if (Capacitor.isNativePlatform()) body.returnToApp = true;
    return api<ICreateReleasePaymentResult>(
      'POST',
      `/releases/${releaseId}/purchase`,
      Object.keys(body).length ? body : undefined
    );
  },

  async syncMyPurchase(purchaseId: number): Promise<void> {
    try {
      await api('GET', '/releases/sync-my-payment', undefined, { purchaseId: String(purchaseId) });
    } catch {
      // как у событий — не блокируем страницу успеха
    }
  }
};
